<template>
    <TagStatus :id="state" :label="label" size="small" type="incomingPurDoc" />
</template>

<script>
import TagStatus from 'vcomponents/common/TagStatus/TagStatus.vue';

export default {
    components: { TagStatus },
    inheritAttrs: false,
    props: {
        state: {
            type: String,
            required: true,
        },
        isElectronicDoc: {
            type: Boolean,
            default: false,
        },
        errorCode: {
            type: Number,
            default: null,
        }
    },
    computed: {
        label() {
            switch (this.state) {
                case 'completed':
                    return this.isElectronicDoc 
                        ? this.$l10n.__('Déposée')
                        : this.$l10n.__('En attente');
                case 'error':
                    return this.$l10n.__(this.errorCode === 1 ? 'Erreur nombre de pages' : 'Erreur technique');
                default:
                    return this.$l10n.__('En cours de traitement');
            }
        },
    },
};
</script>
